import { IGallery, IReoEncryptKey } from '@reolink-cloud/interface';
import { IAccessKeyInfo, IStores, stores as defaultStores } from './stores';

/**
 * 媒体加密模式：
 * - `native`：内容由设备端 AES 加密，需在客户端解密响应体；URL 自带签名鉴权，无需附加头部
 * - `sseC`：S3/Azure SSE-C，云端解密；需要附加 `x-amz-*` / `x-ms-*` CMK 头部
 * - `urlOnly`：仅 URL 需要 `X-Access-Key` 鉴权头，响应体明文
 * - `plain`：无任何加密元信息，按普通资源处理
 */
export type EncryptionMode = 'native' | 'sseC' | 'urlOnly' | 'plain';

export interface IEncryptionMeta {
    mode: EncryptionMode;
    encryptInfo?: IGallery['encrypt'];
    encryptDetail?: IReoEncryptKey;
    accessKeyInfo?: IAccessKeyInfo;
}

export const resolveEncryption = async (
    url: string,
    storesInstance: IStores = defaultStores
): Promise<IEncryptionMeta> => {

    const [encryptInfo, accessKeyInfo] = await Promise.all( [
        storesInstance.encryptKey.get( url ),
        storesInstance.accessKey.get( url )
    ] );

    const encryptDetail = encryptInfo?.keyId
        ? await storesInstance.encryptDetail.get( encryptInfo.keyId )
        : undefined;

    if ( encryptInfo && encryptDetail ) {

        return encryptDetail.mode === 'native-encrypt'
            ? { mode: 'native', encryptInfo, encryptDetail, accessKeyInfo }
            : { mode: 'sseC', encryptInfo, encryptDetail, accessKeyInfo };

    }

    if ( accessKeyInfo ) {

        return { mode: 'urlOnly', accessKeyInfo };

    }

    return { mode: 'plain' };

};
